import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import CreationFormWrapper from "../../components/CreationFormWrapper";
import { usePost, usePut } from "../../hooks/api";
import { apiUrls } from "../../utils/urls";
import { showSuccessSnackbar } from "../../utils/feedback";

export default function TagForm({
  open,
  setOpen,
  initialValue,
  setValue,
  initialUUID,
  multiple,
}) {
  const editing = Boolean(initialUUID);
  const createTagMutation = usePost(apiUrls.tags.tags());
  const editTagMutation = usePut(apiUrls.tags.tags());
  const [formData, setFormData] = useState({
    title: "",
  });
  const handleFocus = () => setError(null);
  const [error, setError] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    let response;
    if (editing) {
      response = await editTagMutation.mutateAsync({
        ...formData,
        tag_uuid: initialUUID,
      });
    } else {
      response = await createTagMutation.mutateAsync(formData);
    }
    const { data } = response;
    if (!data.success) {
      setError(data.reason);
      return;
    }
    const newVal = {
      uuid: data.data.uuid,
      label: data.data.title,
    };
    if (multiple) {
      setValue((curr) => [...curr, newVal]);
    } else {
      setValue(newVal);
    }
    setOpen(false);
    if (editing) {
      showSuccessSnackbar("Tag Updated!");
      return;
    }
    showSuccessSnackbar("New Tag Created!");
  };

  useEffect(() => {
    if (open) {
      setFormData((formData) => ({
        ...formData,
        title: initialValue,
      }));
    }
  }, [open, initialValue]);

  return (
    <CreationFormWrapper
      open={open}
      onClose={handleClose}
      onSubmit={onSubmit}
      error={error}
      title={editing ? `Editing '${initialValue}' Tag` : "Add a new Tag"}
      confirmText={editing ? "Save" : "Create"}
    >
      <Grid container gap={3} marginTop={1}>
        <Grid size={12}>
          <TextField
            fullWidth
            autoFocus
            value={formData.title}
            onChange={(event) =>
              setFormData({
                ...formData,
                title: event.target.value,
              })
            }
            label="Title"
            type="text"
            variant="standard"
            onFocus={handleFocus}
          />
        </Grid>
      </Grid>
    </CreationFormWrapper>
  );
}
